import arEG from "rsuite/locales/ar_EG";

// rsuite's Arabic calendar titles use a cut-short month and a comma
// ("أكتـ, 2025"); the full month reads "أكتوبر 2025".
const formats = {
  ...arEG.Calendar,
  formattedMonthPattern: "MMMM yyyy",
  formattedDayPattern: "d MMMM yyyy",
};

const rsuiteArabic = {
  ...arEG,
  DateTimeFormats: formats,
  Calendar: formats,
  DatePicker: formats,
  DateRangePicker: { ...arEG.DateRangePicker, ...formats },
};

export default rsuiteArabic;
